module.exports = __webpack_public_path__ + "media/St 4-refrigerator-hint.526e6300.wav";